var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium/ArrowDown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0672 11.6922L10.4422 17.3172C10.3841 17.3753 10.3152 17.4214 10.2393 17.4529C10.1635 17.4843 10.0821 17.5005 10 17.5005C9.91786 17.5005 9.83653 17.4843 9.76066 17.4529C9.68478 17.4214 9.61585 17.3753 9.55781 17.3172L3.93281 11.6922C3.81553 11.5749 3.74965 11.4159 3.74965 11.25C3.74965 11.0841 3.81553 10.9251 3.93281 10.8078C4.05008 10.6905 4.20914 10.6247 4.375 10.6247C4.54085 10.6247 4.69991 10.6905 4.81718 10.8078L9.375 15.3664V3.125C9.375 2.95924 9.44084 2.80027 9.55805 2.68306C9.67527 2.56585 9.83424 2.5 10 2.5C10.1658 2.5 10.3247 2.56585 10.4419 2.68306C10.5591 2.80027 10.625 2.95924 10.625 3.125V15.3664L15.1828 10.8078C15.3001 10.6905 15.4591 10.6247 15.625 10.6247C15.7908 10.6247 15.9499 10.6905 16.0672 10.8078C16.1845 10.9251 16.2503 11.0841 16.2503 11.25C16.2503 11.4159 16.1845 11.5749 16.0672 11.6922Z",
    fill: "url(#paint0_linear_2827_13517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2827_13517",
    x1: 16.2503,
    y1: 2.5,
    x2: 3.74965,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3B5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465749,
    stopColor: "#8937A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455AC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.dc6586d75ec4902eaae0b097cd09fd0c.svg";
export { ForwardRef as ReactComponent };